"use client";

import { useEffect } from "react";

export function Legal({ dataId }: { dataId: string }) {
  // https://support.termly.io/en/articles/7904732-how-to-embed-a-policy-on-a-react-site
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://app.termly.io/embed-policy.min.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);
  return (
    <div className="mx-auto mt-24 max-w-2xl">
      <div
        // @ts-expect-error termly expects this unconventional property name
        name="termly-embed"
        data-id={dataId}
        data-type="iframe"
      ></div>
    </div>
  );
}
